/**
 * CMS Feature flag key for the 2026 category-pages carousel browse revamp.
 *
 * Gates the shared DirectoryBrowsePage on /products, /professionals and
 * /projects. Shared by the client hook (useCategoryRevamp) and the server gate
 * (isCategoryRevampActive) so the key lives in one place.
 */
export const CATEGORY_REVAMP_FEATURE_KEY = 'category_pages_revamp_2026';
